import React, { useEffect, useState } from "react";
import api from "../lib/api";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger, DialogFooter, DialogDescription } from "./ui/dialog";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "./ui/select";
import { Sparkle } from "@phosphor-icons/react";

export default function GenerateDialog({ trigger, initial = {}, onStarted }) {
  const [open, setOpen] = useState(false);
  const [tax, setTax] = useState({ universes: [], content_types: [] });
  const [form, setForm] = useState({ content_type: "patient_guide", universe: "salud-piel", topic: "", ...initial });

  useEffect(() => { api.get("/config/taxonomy").then((r) => setTax(r.data)); }, []);
  useEffect(() => { setForm((f) => ({ ...f, ...initial })); }, [JSON.stringify(initial)]);

  const submit = async () => {
    if (!form.topic.trim()) { toast.error("Indiquez un sujet"); return; }
    try {
      await api.post("/content/generate", {
        content_type: form.content_type, universe: form.universe, topic: form.topic,
        topic_id: form.topic_id, source_pmids: form.source_pmids,
      });
      toast.success("Génération lancée", { description: "Le contenu multilingue sera prêt dans ~1-2 min." });
      setOpen(false); onStarted && onStarted();
    } catch (e) { toast.error("Échec du lancement"); }
  };

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>{trigger}</DialogTrigger>
      <DialogContent className="sm:max-w-lg">
        <DialogHeader><DialogTitle className="font-serif text-2xl text-brand flex items-center gap-2">
          <Sparkle weight="fill" size={20} /> Générer un contenu
        </DialogTitle>
        <DialogDescription>Choisissez le type, l'univers et le sujet — l'IA rédige un brouillon multilingue à valider.</DialogDescription></DialogHeader>
        <div className="space-y-4 py-2">
          <div>
            <label className="text-xs font-mono uppercase tracking-wider text-muted-foreground">Type de contenu</label>
            <Select value={form.content_type} onValueChange={(v) => setForm({ ...form, content_type: v })}>
              <SelectTrigger data-testid="gen-type" className="mt-1"><SelectValue /></SelectTrigger>
              <SelectContent>{tax.content_types.map((t) => <SelectItem key={t.key} value={t.key}>{t.label}</SelectItem>)}</SelectContent>
            </Select>
          </div>
          <div>
            <label className="text-xs font-mono uppercase tracking-wider text-muted-foreground">Univers médical</label>
            <Select value={form.universe} onValueChange={(v) => setForm({ ...form, universe: v })}>
              <SelectTrigger data-testid="gen-universe" className="mt-1"><SelectValue /></SelectTrigger>
              <SelectContent>{tax.universes.map((u) => <SelectItem key={u.key} value={u.key}>{u.label}</SelectItem>)}</SelectContent>
            </Select>
          </div>
          <div>
            <label className="text-xs font-mono uppercase tracking-wider text-muted-foreground">Sujet</label>
            <textarea data-testid="gen-topic" value={form.topic} onChange={(e) => setForm({ ...form, topic: e.target.value })}
              rows={2} placeholder="Ex : Photoprotection quotidienne : guide fondé sur les preuves"
              className="w-full mt-1 px-3 py-2 rounded-md border border-border text-sm focus:outline-none focus:ring-2 focus:ring-brand/30" />
          </div>
        </div>
        <DialogFooter>
          <button data-testid="gen-submit" onClick={submit}
            className="bg-brand hover:bg-brand-hover text-white px-4 py-2 rounded-md text-sm font-medium transition-colors">
            Lancer la génération IA
          </button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
